import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Metric from './components/Metric';
import MHCPTool from './components/MHCPTools';
import AIAgent from './components/AIAgent';
import GPCCMP from './components/GPCCMP';

import Navigation from './components/Navigation';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { NavigationProvider } from './utilities/NavigationContext';

class App extends React.Component {

  render() {

    return (
      <Router>

    
          <ToastContainer />

            <Routes>

              <Route path="/" element={<Metric />} />
              <Route path='/mhcp-generator' element={<MHCPTool />} />
              <Route path='/mhcp-agent-test' element={<AIAgent />} />
              <Route path='/gpccmp-generator' element={<GPCCMP />} />
           

            </Routes>
       
 
      </Router>
    );
  }
}

export default App;
